import FingerprintJS from "@fingerprintjs/fingerprintjs";
import Cookies from "js-cookie";
import { useCallback, useEffect, useRef, useState } from "react";
import { businessCategoryEnum, getIDFromEnum } from "./allEnums";
import * as eventLogger from "../eventLogger";
import moment from "moment";

const checkNameSpace = /[-\w]+\s[-\w]+/;
const validEmailRegex =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
const checkNumberRegex = /^\d+$/;
const checkPhoneRegex = /^(070|080|090|081)[0-9]{8}$/;
let error = "";

export const formatMoney = (amount, decimalCount = 2, decimal = ".", thousands = ",") => {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
        const negativeSign = amount < 0 ? "-" : "";
        let i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
        let j = i.length > 3 ? i.length % 3 : 0;
        return (
            negativeSign +
            (j ? i.substr(0, j) + thousands : "") +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
            (decimalCount
                ? decimal +
                  Math.abs(amount - i)
                      .toFixed(decimalCount)
                      .slice(2)
                : ""
            ).replace(/\.00$/, "")
        );
    } catch (e) {}
};

export const formatBalance = (amount, decimalCount = 2, decimal = ".", thousands = ",") => {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
        const negativeSign = amount < 0 ? "-" : "";
        let i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
        let j = i.length > 3 ? i.length % 3 : 0;
        return (
            negativeSign +
            (j ? i.substr(0, j) + thousands : "") +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
            (decimalCount
                ? decimal +
                  Math.abs(amount - i)
                      .toFixed(decimalCount)
                      .slice(2)
                : "")
        );
    } catch (e) {}
};

export function formatKoboBalance(amount) {
    const options = {
        style: "currency",
        currency: "NGN",
        minimumFractionDigits: 2,
    };
    amount = amount / 100;
    const formatter = new Intl.NumberFormat("en-NG", options);
    return formatter.format(amount);
}

export const getReference = () => {
    let text = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-.=";
    for (let i = 0; i < 15; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
};

export const generateRandomference = () => {
    const timestamp = Date.now(); // Get the current timestamp in milliseconds
    const randomNumber = Math.floor(Math.random() * 10000000000000000);
    return `${timestamp}-${randomNumber}`;
};

export const titleCase = (str) => {
    var splitStr = str.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(" ");
};

export const hexToBase64 = (hex) => {
    var bytes = [];
    for (var i = 0; i < hex.length; i += 2) {
        bytes.push(String.fromCharCode(parseInt(hex.substr(i, 2), 16)));
    }
    return bytes.join("");
};

export const base64ToHex = (base64String) => {
    var raw = atob(base64String); // Decode base64
    var hex = "";
    for (var i = 0; i < raw.length; i++) {
        var hexChar = raw.charCodeAt(i).toString(16);
        hex += hexChar.length === 2 ? hexChar : "0" + hexChar;
    }
    return hex;
};

export const byteStringToHex = (byteString) => {
    var hex = "";
    for (var i = 0; i < byteString.length; i++) {
        var hexChar = byteString.charCodeAt(i).toString(16);
        hex += hexChar.length === 2 ? hexChar : "0" + hexChar;
    }
    return hex;
};

export const getHumanDate = (isoformat) => {
    var readable = new Date(isoformat); // When we pass the ISO format to the JS Date constructor, the return is "Fri Jul 04 2014 21:06:08 GMT-0400 (Eastern Daylight Time)"
    var m = readable.getMonth(); // returns 6 (note that this number is one less than the number of the month in isoformat)
    var d = readable.getDate(); // returns 15
    var y = readable.getFullYear(); // returns 2012

    // we define an array of the months in a year
    var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    // we get the text name of the month by using the value of m to find the corresponding month name
    var mlong = months[m];
    return mlong + " " + d + ", " + y;
};

export const getTooltipDate = (isoformat) => {
    var readable = new Date(isoformat); // When we pass the ISO format to the JS Date constructor, the return is "Fri Jul 04 2014 21:06:08 GMT-0400 (Eastern Daylight Time)"
    var m = readable.getMonth(); // returns 6 (note that this number is one less than the number of the month in isoformat)
    var d = readable.getDate(); // returns 15
    var y = readable.getFullYear(); // returns 2012

    // we define an array of the months in a year
    var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    // we get the text name of the month by using the value of m to find the corresponding month name
    var mlong = months[m];
    return d + " " + mlong + ", " + y;
};

export const getXAxisDate = (isoformat) => {
    var readable = new Date(isoformat); // When we pass the ISO format to the JS Date constructor, the return is "Fri Jul 04 2014 21:06:08 GMT-0400 (Eastern Daylight Time)"
    var m = readable.getMonth(); // returns 6 (note that this number is one less than the number of the month in isoformat)
    var d = readable.getDate(); // returns 15
    // we define an array of the months in a year
    var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    // we get the text name of the month by using the value of m to find the corresponding month name
    var mlong = months[m];
    const dd = +d < 10 ? "0" + d : d;
    return mlong + " ‘" + dd;
};

export const isoStringOffset = (newDate) => {
    var date = new Date(newDate); // Or the date you'd like converted.
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
};

export const getDate = (isoformat) => {
    var readable = new Date(isoformat); // When we pass the ISO format to the JS Date constructor, the return is "Fri Jul 04 2014 21:06:08 GMT-0400 (Eastern Daylight Time)"
    var m = readable.getMonth(); // returns 6 (note that this number is one less than the number of the month in isoformat)
    var d = readable.getDate(); // returns 15

    // we define an array of the months in a year
    var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    // we get the text name of the month by using the value of m to find the corresponding month name
    var mlong = months[m];
    return mlong + " " + d + ".";
};

export const getReceiptDate = (isoformat) => {
    var readable = new Date(isoformat); // When we pass the ISO format to the JS Date constructor, the return is "Fri Jul 04 2014 21:06:08 GMT-0400 (Eastern Daylight Time)"
    var m = readable.getMonth(); // returns 6 (note that this number is one less than the number of the month in isoformat)
    var d = readable.getDate(); // returns 15
    var y = readable.getFullYear();
    // we define an array of the months in a year
    var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    // we get the text name of the month by using the value of m to find the corresponding month name
    var mlong = months[m];
    return mlong + " " + d + ", " + y;
};

export const getTableDate = (isoformat) => {
    var readable = new Date(isoformat); // When we pass the ISO format to the JS Date constructor, the return is "Fri Jul 04 2014 21:06:08 GMT-0400 (Eastern Daylight Time)"
    var m = readable.getMonth(); // returns 6 (note that this number is one less than the number of the month in isoformat)
    var d = readable.getDate(); // returns 15
    var y = readable.getFullYear();
    // we define an array of the months in a year
    var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    // we get the text name of the month by using the value of m to find the corresponding month name
    var mlong = months[m];
    return d + " " + mlong + " " + y;
};

export const getMonth = (months) => {
    var dateObj = new Date();
    var month = new Date(dateObj.setMonth(dateObj.getMonth() + months)).toISOString(); //
    return month;
};

export const getSummaryTime = (date) => {
    const dd = new Date(date);
    return new Intl.DateTimeFormat("en-NG", {
        hour: "numeric",
        minute: "numeric",
        hourCycle: "h12",
    }).format(dd);
};

export const getDesireTime = (time) => {
    var newDate = new Date(time);
    newDate.setHours(newDate.getHours() + 1);
    var hours = newDate.getHours();
    var minutes = newDate.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
};

export const closeModalOnClick = (event) => {
    document.querySelector(".modal-backdrop").addEventListener("click", (e) => {
        const isVisible = (elem) =>
            !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);

        Array.from(document.querySelectorAll(".modal-backdrop .modal-content")).forEach(
            (element) => {
                if (!element.contains(e.target) && isVisible(element)) {
                    event();
                }
            },
        );
    });
};

export const closeMobileModalOnClick = (event) => {
    document.querySelector(".kuda-mobile--menu").addEventListener("click", (e) => {
        const isVisible = (elem) =>
            !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);

        Array.from(document.querySelectorAll(".kuda-menu--wrap")).forEach((element) => {
            if (!element.contains(e.target) && isVisible(element)) {
                event();
            }
        });
    });
};

export const closeMoreOnClick = (event) => {
    document.querySelector("body").addEventListener("click", (e) => {
        const isVisible = (elem) =>
            !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);

        Array.from(document.querySelectorAll(".pop")).forEach((element) => {
            if (!element.contains(e.target) && isVisible(element)) {
                event();
            }
        });
    });
};

export const fallbackCopyTextToClipboard = (text) => {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed"; //avoid scrolling to bottom
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        document.execCommand("copy");
    } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
    }

    document.body.removeChild(textArea);
};

export const copyTextToClipboard = (text) => {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(
        function () {},
        function (err) {
            console.error("Async: Could not copy text: ", err);
        },
    );
};

export const toLocaleTime = (date) => {
    var isoDateTime = new Date(date);
    return isoDateTime.toLocaleDateString();
};

export const getBetweenMonths = (date1, date2) => {
    var year1 = date1.getFullYear();
    var year2 = date2.getFullYear();
    var month1 = date1.getMonth();
    var month2 = date2.getMonth();
    if (month1 === 0) {
        //Have to take into account
        month1++;
        month2++;
    }
    return (year2 - year1) * 12 + (month2 - month1);
};

export const capitalize = (s) => {
    if (s) {
        return s.toLowerCase().replace(/\b./g, function (a) {
            return a.toUpperCase();
        });
    } else {
        return "";
    }
};

export const daysInThisMonth = () => {
    var date = new Date();
    var time = new Date(date.getTime());
    time.setMonth(date.getMonth() + 1);
    time.setDate(0);
    var days = time.getDate() > date.getDate() ? time.getDate() - date.getDate() : 0;
    return days;
};

export const totalDaysInThisMonth = () => {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
};

var currency_symbols = {
    USD: "$", // US Dollar
    EUR: "€", // Euro
    CRC: "₡", // Costa Rican Colón
    GBP: "£", // British Pound Sterling
    ILS: "₪", // Israeli New Sheqel
    INR: "₹", // Indian Rupee
    JPY: "¥", // Japanese Yen
    KRW: "₩", // South Korean Won
    NGN: "₦", // Nigerian Naira
    PHP: "₱", // Philippine Peso
    PLN: "zł", // Polish Zloty
    PYG: "₲", // Paraguayan Guarani
    THB: "฿", // Thai Baht
    UAH: "₴", // Ukrainian Hryvnia
    VND: "₫", // Vietnamese Dong
};

export const formatCurrency = (currency) => {
    if (currency_symbols[currency] !== undefined) {
        return currency_symbols[currency];
    }
    return `${currency} `;
};

export const currentYear = () => {
    var dt = new Date(); //Date constructor
    return dt.getUTCFullYear();
};

export const detectMobile = () => {
    // device detection
    if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
            navigator.userAgent,
        ) ||
        // eslint-disable-next-line no-useless-escape
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            navigator.userAgent.substr(0, 4),
        )
    ) {
        return true;
    } else {
        return false;
    }
};

export const inThirty = () => {
    const inThirtyMinutes = new Date(new Date().getTime() + 30 * 60 * 1000);
    return inThirtyMinutes;
};

export const checkEmpty = (obj) => {
    let check = false;
    for (var key in obj) {
        if (obj[key] === null || obj[key] === "") {
            check = true;
            break;
        }
    }
    return check;
};

var i = 0;
export const uploadProgressBar = (elemId, state) => {
    if (i === 0) {
        i = 1;
        var elem = document.getElementById(elemId);

        if (!elem) return;
        var width = 1;
        var id = setInterval(frame, 50);
        function frame() {
            if (width >= 100) {
                clearInterval(id);
                i = 0;
            } else {
                width++;
                if (state === "loading") {
                    elem.style.width = 60 + "%";
                } else if (state === "success") {
                    elem.style.width = 100 + "%";
                } else {
                    return;
                }
            }
        }
    }
};

export const getStrInitials = (booleanValue, str) => {
    // booleanValue is by default not provided. Please always pass in a false boolean value
    if (str === "" || !str) {
        return;
    }
    if (typeof booleanValue == "undefined") {
        var glue = true;
    }

    if (str !== undefined || str !== "") {
        var initials = str.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g); // gives you an array
    }

    if (glue || initials?.length === 1) {
        return initials.join("");
    }

    if (initials?.length > 2) {
        const finalInitials = `${initials[0]}${initials[2]}`;
        return finalInitials;
    } else if (initials?.length === 2) {
        const finalInitials = `${initials[0]}${initials[1]}`;
        return finalInitials;
    }
    // var pieces = str.split(" ");
    // var firstLetetr = pieces[0].charAt(0);
    // var secondLetter =
    // return `${pieces[0]}${pieces[pieces.length-1]}}`
};

export const getIndividualNames = (str) => {
    const strArray = str.split(" ");
    return {
        firstName: strArray[0],
        middleName: strArray[1],
        lastName: strArray[2],
    };
};

export const getFirstLetter = (str) => {
    return str.charAt(0);
};

export const serializeForm = (form) => {
    var obj = {};
    var formData = form;
    for (var key of formData.keys()) {
        obj[key] = formData.get(key);
    }
    return obj;
};

export const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            let encoded = reader.result.toString().replace(/^data:(.*,)?/, "");
            if (encoded.length % 4 > 0) {
                encoded += "=".repeat(4 - (encoded.length % 4));
            }
            resolve(encoded);
        };
        reader.onerror = (error) => reject(error);
    });
};

export function hexAToRGBA(h, percent) {
    let r = 0,
        g = 0,
        b = 0;
    // a = 1;

    if (h.length === 5) {
        r = "0x" + h[1] + h[1];
        g = "0x" + h[2] + h[2];
        b = "0x" + h[3] + h[3];
        // a = "0x" + h[4] + h[4];
    } else if (h.length === 9) {
        r = "0x" + h[1] + h[2];
        g = "0x" + h[3] + h[4];
        b = "0x" + h[5] + h[6];
        // a = "0x" + h[7] + h[8];
    }
    //   a = +(a / 255).toFixed(3);

    return "rgba(" + +r + "," + +g + "," + +b + "," + percent + ")";
}

export function hex2rgb(color, percent = 1) {
    // Regex pattern to match a valid 6-digit hex color
    var pattern_color = /^#([A-Fa-f0-9]{6})$/;

    // Check if the color matches the hex pattern
    if (pattern_color.test(color)) {
        // Remove the '#' and get the RGB values
        var hex_color = color.replace("#", ""),
            r = parseInt(hex_color.substring(0, 2), 16),
            g = parseInt(hex_color.substring(2, 4), 16),
            b = parseInt(hex_color.substring(4, 6), 16);

        // Return the RGB(A) color string
        return `rgba(${r},${g},${b},${percent})`;
    }

    // If the input color is invalid, return a default value or null
    return null;
}

export function roundToTwoDecimals(num, decimalPlaces) {
    return Number(Math.round(num + "e" + decimalPlaces) + "e-" + decimalPlaces) + 0;
}

export const getRefreshCount = () => {
    return parseInt(sessionStorage.getItem("refreshCount"));
};

export const setRefreshCount = (count) => {
    count && sessionStorage.setItem("refreshCount", count + 1);
};

export const userExists = (arr, key, value) => {
    return arr.some(function (el) {
        return el[key] === value;
    });
};

export const camelCase = (str) => {
    return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, "");
};

export const calculateEndDate = (startDate, frequencyType, duration) => {
    function getDuration() {
        if (frequencyType === "Daily") {
            let durationInDays = duration;
            return durationInDays;
        } else if (frequencyType === "Weekly") {
            let durationInDays = duration * 7; // 7 being the number of days in a week
            return durationInDays;
        } else if (frequencyType === "Monthly") {
        } else if (frequencyType === "Just Once") {
            let durationInDays = 1;
            return durationInDays;
        } else {
            return 1;
        }
    }
    var date1 = new Date(startDate);
    date1.setDate(date1.getDate() + getDuration());
    var dateAsAString = date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-" + date1.getDate();
    var newDateString = new Date(dateAsAString);
    return isoStringOffset(newDateString);
};

// Tue Mar 30 2021 00:00:00 GMT+0100 (West Africa Standard Time)

export const monthsFromDate = (current, months) => {
    const now = new Date(current);
    return now.setMonth(now.getMonth() + parseInt(months));
};
export const weeksFromDate = (current, weeks) => {
    const now = new Date(current);
    return now.setDate(now.getDate() + weeks * 7);
};
export const daysFromDate = (current, days) => {
    const now = new Date(current);
    return now.setDate(now.getDate() + parseInt(days));
};

export const formatPhoneNumber = (value) => {
    var re = /\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})/g;
    var subst = "($1) $2 $3";
    return value.replace(re, subst);
};

export const checkBlackList = (word, array) => {
    return array.some((substring) => word.split(" ").includes(substring.toLowerCase()));
};

export const getBlacklistMatch = (array1, array2) => {
    return array2.filter((element) => array1.includes(element.toLowerCase()));
};

export const convertArrayToSentence = (array) => {
    return (
        array.slice(0, -2).join(", ") +
        (array.slice(0, -2).length ? ", " : "") +
        array.slice(-2).join(" & ")
    );
};

export const getInitials = (str) => {
    const strArray = str.split(" ");
    return `${strArray[0].charAt(0)}${strArray[strArray.length - 1].charAt(0)}`;
};

export const getFirstWordBillers = (str, lowerCase) => {
    const codeLines = str.split("|");

    for (var i = 0; i < codeLines.length; i++) {
        const first = codeLines[i].split(" ").shift();
        return lowerCase && lowerCase === true ? first.toLowerCase() : first;
    }
};

export const generateUUID = () => {
    let d = new Date().getTime(),
        d2 = (performance && performance.now && performance.now() * 1000) || 0;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : r && 0x7 | 0x8).toString(16);
    });
};

export const formatTIN = (str, n) => {
    var ret = [];
    var i;
    var len;

    for (i = 0, len = str.length; i < len; i += n) {
        ret.push(str.substr(i, n));
    }

    return ret;
};

export const checkAllTrue = (obj) => {
    return Object.values(obj).every((item) => item === true);
};

export const convertSentenceToUrl = (string="") => {
    return string.toLowerCase().replace(/[^A-Z0-9]+/gi, "-");
};

export const setInputFilter = (textbox, inputFilter) => {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(
        function (event) {
            textbox.addEventListener(event, function () {
                if (inputFilter(this.value)) {
                    this.oldValue = this.value;
                    this.oldSelectionStart = this.selectionStart;
                    this.oldSelectionEnd = this.selectionEnd;
                } else if (this.hasOwnProperty("oldValue")) {
                    this.value = this.oldValue;
                    this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
                } else {
                    this.value = "";
                }
            });
        },
    );
};

export const offset = (el) => {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
};

// =========== Validate Utils ==============
export const validatePhoneNumber = (value) => {
    if (!checkNumberRegex.test(value)) {
        error = "Must contain only Numbers";
    } else if (value.length < 11 || value.length > 11) {
        error = "Must be a 11 digit Number";
    } else if (!checkPhoneRegex.test(value)) {
        error = "Must be a valid Nigerian number";
    } else {
        error = "";
    }
    return error;
};
export const validateNumber = (value) => {
    if (!checkNumberRegex.test(value)) {
        error = "Must contain only Numbers";
    } else {
        error = "";
    }
    return error;
};
export const validateAccountNumber = (value) => {
    if (!checkNumberRegex.test(value)) {
        error = "Must contain only Numbers";
    } else if (value.length < 10 || value.length > 10) {
        error = "Must be a 10 digit Number";
    } else {
        error = "";
    }
    return error;
};
export const validateBvnNumber = (value) => {
    if (!checkNumberRegex.test(value)) {
        error = "Must contain only Numbers";
    } else if (value.length < 11 || value.length > 11) {
        error = "Must be a 11 digit Number";
    } else {
        error = "";
    }
    return error;
};
export const validatePayCode = (value) => {
    if (!checkNumberRegex.test(value)) {
        error = "Must contain only Numbers";
    } else if (value.length < 11) {
        error = "Valid 11 digit paycode number required";
    } else {
        error = "";
    }
    return error;
};
export const validateSingleName = (value) => {
    if (value.length < 2) {
        error = "Name must not be less that 2 characters!";
    } else {
        error = "";
    }
    return error;
};

export const validateNinNumber = (value) => {
    if (value.length < 11) {
        error = "NIN must not be less than 11 characters!";
    } else {
        error = "";
    }
    return error;
};
export const validateName = (value) => {
    if (value.length < 2) {
        error = "Name must not be less that 2 characters!";
    } else if (!checkNameSpace.test(value)) {
        error = "Name must include a space and then second name";
    } else {
        error = "";
    }
    return error;
};
export const validateEmail = (value) => {
    !validEmailRegex.test(value) ? (error = "Email is invalid") : (error = "");
    return error;
};
export const validateExpiryDate = (s) => {
    // Check 2-2 digits
    if (!/^(0[1-9]|1[0-2])\/\d{2}$/.test(s)) {
        return false;
    }

    // Check month is 1 to 12 inclusive
    var b = s.split("/");
    if (b[0] < 1 || b[0] > 12) {
        return false;
    }

    // Check is this month or later
    var d = new Date();
    var c = (d.getFullYear() / 100) | (0 + "");
    if (new Date(c + b[1], b[0], 1) < d) {
        return false;
    }

    return true;
};
// =========== Validate Utils End ==========

export const checkFalseObject = (obj) => {
    let check = false;
    for (var key in obj) {
        if (!obj[key]) {
            check = true;
            break;
        }
    }
    return check;
};

export const getFingerPrint = async () => {
    const fp = await FingerprintJS.load();

    // The FingerprintJS agent is ready.
    // Get a visitor identifier when you'd like to.
    const result = await fp.get();

    // This is the visitor identifier:
    const visitorId = result.visitorId;
    return visitorId;
};

export const logout = async () => {
    eventLogger.reset();

    Cookies.remove("intercom-id-yfeptktb");
    Cookies.remove("intercom-session-yfeptktb");
    if (window.Intercom) {
        window.Intercom("shutdown");
    }
    Cookies.remove("kudaAppToken");
    Cookies.remove("kudaUserEmail");
    Cookies.remove("kudaAccountNumber");
    Cookies.remove("kudaUserID");
    Cookies.remove("kudaSmeID");
    Cookies.remove("expiresIn");
    Cookies.remove("ntbUploadRequired");
    Cookies.remove("newAccount");
    Cookies.remove("groupCustomerId");
    Cookies.remove("fromSalesMode");
    localStorage.removeItem("kudaBalance");
    localStorage.removeItem("kudaBeneficiaries");
    localStorage.removeItem("kudaRecents");
    localStorage.removeItem("KudaUserInfo");
    localStorage.removeItem("isGetToKnowYouDone");
    localStorage.removeItem("isDocsUpload");
    localStorage.removeItem("lastTransaction");
    localStorage.removeItem("segmentViewDashboardFlag");
    // window.location.href = "/login";
    sessionStorage.removeItem("kudaUserEmail");
    sessionStorage.removeItem("kudaUserID");
    sessionStorage.removeItem("userID");
    sessionStorage.removeItem("refreshCount");
    sessionStorage.removeItem("userFromLogin");
    sessionStorage.removeItem("accountToMigrate");
    sessionStorage.removeItem("accountType");
    sessionStorage.removeItem("kudaAppToken");
    sessionStorage.removeItem("LOGIN_ACCOUNT_SELECTED");

    if (window.fcWidget) {
        // window.fcwidget.user.clear()
        window.fcWidget.user.clear().then(
            function () {},
            function () {},
        );
    }

    setTimeout(() => {
        Cookies.remove("kudaAppRefreshToken");
    }, 5000);
};

export const reportTransactionEmailBody = ({
    name,
    amount,
    datePaid,
    postingType,
    merchant,
    fee,
    description,
    category,
    sessionID,
    referenceID,
}) => {
    const isPosting2 = postingType === 2;
    const paymentMethod = isPosting2 ? "Money Received" : "Money Sent";
    const FromOrTo = isPosting2 ? "From" : "To";
    const sessionIdOrRefId = sessionID ? "Session ID" : "Reference ID";

    const body = encodeURIComponent(
        `Transaction Details \n \n Name: ${name} \n Amount: ${amount} \n Paid On: ${datePaid} \n Payment Method: ${paymentMethod} \n ${FromOrTo}: ${merchant} \n Fee: ${fee} \n Description: ${description} \n Category: ${category} \n ${sessionIdOrRefId}: ${
            sessionID || referenceID
        }`,
    );
    return body;
};

export const convertDateToYMD = (date) => {
    const newDate = new Date(date);
    const year = newDate.getFullYear();
    let month = newDate.getMonth() + 1;
    let dt = newDate.getDate();

    if (dt < 10) {
        dt = "0" + dt;
    }
    if (month < 10) {
        month = "0" + month;
    }

    const convertedDate = `${year}-${month}-${dt}`;

    return convertedDate.toString();
};

export const convertDateToDMY = (date) => {
    const newDate = new Date(date);
    const year = newDate.getFullYear();
    let month = newDate.getMonth() + 1;
    let dt = newDate.getDate();

    if (dt < 10) {
        dt = "0" + dt;
    }
    if (month < 10) {
        month = "0" + month;
    }

    const convertedDate = `${dt}/${month}/${year}`;

    return convertedDate.toString();
};

const initialTimerState = {
    minutes: "00",
    seconds: "00",
};

const fiveMinutes = 60 * 5;

export const useTimer = (duration) => {
    const timerInteval = useRef(null);
    const minutes = useRef(null);
    const seconds = useRef(null);
    const timer = useRef(duration || fiveMinutes);

    const [time, setTime] = useState({ minutes: "01", seconds: "00" });

    const startTimer = useCallback(() => {
        timerInteval.current = setInterval(() => {
            minutes.current = parseInt(timer.current / 60, 10);
            seconds.current = parseInt(timer.current % 60, 10);

            const calMinutes = minutes.current < 10 ? "0" + minutes.current : minutes.current;
            const calSeconds = seconds.current < 10 ? "0" + seconds.current : seconds.current;

            setTime({
                minutes: calMinutes,
                seconds: calSeconds,
            });

            if (--timer.current < 0) {
                timer.current = duration;
            }
        }, 1000);
    }, [duration]);

    const clearTimer = useCallback(() => {
        clearInterval(timerInteval.current);
        setTime(initialTimerState);
        minutes.current = "00";
        seconds.current = "00";
        timer.current = duration;
    }, [duration]);

    const restartTimer = () => {
        clearTimer();
        startTimer();
    };

    useEffect(() => {
        startTimer();

        return () => {
            clearTimer();
        };
    }, [clearTimer, startTimer]);

    return {
        restartTimer,
        clearTimer,
        minutes: time.minutes,
        seconds: time.seconds,
    };
};

export const getDateDay = (date) => {
    const newDate = new Date(date);
    let dt = newDate.getDate();

    if (dt < 10) {
        dt = "0" + dt;
    }

    const convertedDate = `${dt}`;

    return convertedDate.toString();
};

export const truncate = (str, lim) => {
    if (!str) return "";
    const limit = lim || 12;
    return str?.length > limit ? str?.substr(0, limit - 1) + "..." : str;
};

export const formatNaira = (val) => {
    return new Intl.NumberFormat("en-NG", {
        style: "currency",
        currency: "NGN",
    }).format(val);
};

export const formatPayoneerBalance = (val, currency) => {
    if (!currency) return "";
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency,
    }).format(val);
};

export const convertObjectToArray = (obj) => {
    const newArray = Object.keys(obj).map((key) => {
        return [`${key}`, obj[`${key}`]];
    });
    return newArray;
};
export const castCategory = (categoryID) => {
    let transactionCategories = JSON.parse(localStorage.getItem("transactionCategories"));
    let category = transactionCategories.filter((item) => item.id === categoryID);

    if (category.length === 0) {
        return {
            icon: `
            <svg
                width="39"
                height="39"
                viewBox="0 0 39 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="19.5"
                    cy="19.5"
                    r="19.5"
                    fill="#DBDCE0"
                />
                <path
                    d="M21.0492 11.83H24.4935L18.4441 19.4655L24.6305 27.101H21.0149L14.6232 19.7736L21.0492 11.83Z"
                    fill="white"
                />
                <path
                    d="M16.0435 11.83H18.4504L14.7799 19.7736L18.2793 27.101H15.667L12.5441 19.7052L16.0435 11.83Z"
                    fill="white"
                />
                <path
                    d="M12.6636 11.83H14.033L12.5638 19.7052L14.033 27.101H12.6636L11.2286 19.7052L12.6636 11.83Z"
                    fill="white"
                />
                <path
                    d="M10.6995 11.83H11.4672V27.101H10.6995V11.83Z"
                    fill="white"
                />
                <circle
                    cx="26.6337"
                    cy="25.4578"
                    r="1.71162"
                    fill="white"
                />
            </svg>`,
            name: "Unknown",
        };
    }

    return {
        icon: category[0].iconUrl,
        name: category[0].name,
        backgroundColor: category[0].backgroundColor,
        colorCode: category[0].colorCode,
        description: category[0].description,
        progressColor: category[0].progressColor,
    };
};

export const castMethod = (methodID) => {
    let transactionMethods = JSON.parse(localStorage.getItem("transactionMethods"));
    let method = transactionMethods.filter((item) => item.id === methodID);
    if (method.length > 0) {
        return { name: method[0].name };
    } else {
        return { id: 26, name: "Unknown" };
    }
};

export const castTags = (TagID, categoryID) => {
    let transactionTags = JSON.parse(localStorage.getItem("transactionTags"));

    let tag = transactionTags.filter((item) => parseInt(item.tagId) === TagID);

    if (
        TagID === "99999" ||
        TagID === 99999 ||
        TagID === 9999999 ||
        TagID === "9999999" ||
        tag.length === 0
    ) {
        return castCategory(categoryID);
    }

    return {
        icon: tag[0].iconUrl,
        id: tag[0].id,
        name: tag[0].tagName,
        category: tag[0].categoryId,
    };
};

export const castTagsNew = (TagID, categoryID) => {
    let transactionTags = JSON.parse(localStorage.getItem("transactionTags"));

    let tag = transactionTags.filter((item) => item.tagId === TagID);

    if (tag.length === 0) {
        return castCategory(categoryID);
    }
    return {
        icon: tag[0].iconUrl,
        id: tag[0].id,
        name: tag[0].tagName,
        category: tag[0].categoryId,
    };
};

export const KoboToNaira = (amount) => {
    return amount / 100;
};

export function graphAmountFormatter(num) {
    if (num > 999 && num < 1000000) {
        return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
    } else if (num >= 1000000 && num < 1000000000) {
        return (num / 1000000).toFixed(0) + "M"; // convert to M for number from > 1 million
    } else if (num >= 1000000000) {
        return (num / 1000000000).toFixed(0) + "B";
    } else if (num <= 999) {
        return num; // if value < 1000, nothing to do
    }
}

export const pushSiftEvent = async ({ email, accountNumber, brandName }) => {
    const beaconKey = process.env.REACT_APP_SIFT_BEACON_KEY;
    var _sift = window._sift || [];

    _sift.push(["_setAccount", beaconKey]);
    _sift.push(["_setUserId", email]);
    _sift.push(["_setBusinessAccountId", accountNumber]);
    _sift.push(["_setBrandName", brandName]);
    // _sift.push(["_setSessionId", sessionID]);
    _sift.push(["_trackPageview"]);
};

export const getAccessLevel = (userRole) => {
    switch (userRole) {
        case 5:
            return "Viewer";

        case 4:
            return "Approver";
        case 3:
            return "Initiator";
        case 2:
            return "Approver,Initiator";
        case 1:
            return "Admin";
        default:
            return "";
    }
};

export const getAccountType = (singleSmeAccount) => {
    let accountType = singleSmeAccount.businessCategory;

    switch (accountType) {
        case getIDFromEnum("BusinessName", businessCategoryEnum):
            return `Full Business (Business Name)`;

        case getIDFromEnum("LimitedLiability", businessCategoryEnum):
            return "Full Business (Limited Liability)";

        case getIDFromEnum("Freelancer", businessCategoryEnum):
        default:
            return "Freelancer";
    }
};

export function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
}

export function formatKoboToNaira(amount) {
    const options = {
        style: "currency",
        currency: "NGN",
        minimumFractionDigits: 2,
    };
    // if its a whole, naira amount, leave off the .00
    if (amount % 100 === 0) options.minimumFractionDigits = 0;
    amount = amount / 100;
    const formatter = new Intl.NumberFormat("en-NG", options);
    return formatter.format(amount);
}

export const getDuration = (t0, t1, showSeconds) => {
    let d = new Date(t1) - new Date(t0);
    let weekdays = Math.floor(d / 1000 / 60 / 60 / 24 / 7);
    let days = Math.floor(d / 1000 / 60 / 60 / 24 - weekdays * 7);
    let hours = Math.floor(d / 1000 / 60 / 60 - weekdays * 7 * 24 - days * 24);
    let minutes = Math.floor(d / 1000 / 60 - weekdays * 7 * 24 * 60 - days * 24 * 60 - hours * 60);
    let seconds = Math.floor(
        d / 1000 -
            weekdays * 7 * 24 * 60 * 60 -
            days * 24 * 60 * 60 -
            hours * 60 * 60 -
            minutes * 60,
    );
    //eslint-disable-next-line
    let milliseconds = Math.floor(
        d -
            weekdays * 7 * 24 * 60 * 60 * 1000 -
            days * 24 * 60 * 60 * 1000 -
            hours * 60 * 60 * 1000 -
            minutes * 60 * 1000 -
            seconds * 1000,
    );
    let t = {};
    ["weekdays", "days", "hours", "minutes", "seconds", "milliseconds"].forEach((q) => {
        //eslint-disable-next-line
        if (eval(q) > 0) {
            //eslint-disable-next-line
            t[q] = eval(q);
        }
    });
    if (days > 0) {
        return `${getHumanDate(t0)}`;
    }
    if (hours > 0) {
        return `${t.hours}h`;
    } else if (minutes > 0) {
        return `${minutes}m`;
    } else {
        return showSeconds ? `${seconds}s` : "now";
    }
};

export const getDurationInSeconds = (t0, t1) => {
    let d = new Date(t1) - new Date(t0);
    return Math.abs(d / 1000);
};

export const getBillerName = (name) => {
    switch (name) {
        case "Internet Data":
            return "Internet";
        case "Betting":
            return "Betting";
        case "CableTV":
            return "TV";
        case "Electricity":
            return "Electricity";
        case "Transport and Tolls":
            return "Transport";
        default:
            return name;
    }
};

export const openURLInNewWindow = (url) => window.open(url, "_blank", "noopener,noreferrer");

export const openURLInSameWindow = (url) => window.open(url, "_self", "noopener,noreferrer");

const cached = new WeakMap();

/**
 * @param {any} a
 * @param {any} b
 * @return {boolean}
 */
export function isEqual(a, b) {
    if (a === null || b === null) {
        return a === b;
    }

    if (typeof a !== "object" || typeof b !== "object") {
        return a === b;
    }

    const dataTypeA = detectDataType(a);
    const dataTypeB = detectDataType(b);
    if (dataTypeA !== dataTypeB) return false;

    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;

    const symbolsA = Object.getOwnPropertySymbols(a);
    const symbolsB = Object.getOwnPropertySymbols(b);
    if (symbolsA.length !== symbolsB.length) return false;

    if (cached.get(a)?.has(b)) return true;
    if (cached.get(b)?.has(a)) return true;

    cache(a, b, cached);

    const propertyNamesA = [...keysA, ...symbolsA];

    for (const propertyNameA of propertyNamesA) {
        if (!b.hasOwnProperty(propertyNameA)) return false;

        const propertyValueA = a[propertyNameA];
        const propertyValueB = b[propertyNameA];

        if (!isEqual(propertyValueA, propertyValueB)) {
            return false;
        }
    }

    return true;
}

function detectDataType(data) {
    if (Array.isArray(data)) return "array";
    return "object";
}

function cache(a, b, cached) {
    let setForA = cached.get(a);
    if (!setForA) {
        cached.set(a, (setForA = new Set()));
    }
    setForA.add(b);

    let setForB = cached.get(b);
    if (!setForB) {
        cached.set(b, (setForB = new Set()));
    }
    setForB.add(a);
}

/**
 * This is a Javascript function that returns a debounced version of a given function with a specified
 * delay.
 * @param {F} func - The function that needs to be debounced.
 * @param {number} delay - The `delay` parameter is a number that represents the time in milliseconds
 * for which the execution of the `func` function should be delayed after the last call to the returned
 * function. This is used to implement a debounce function that delays the execution of a function
 * until a certain amount of time has passed without
 * @returns A debounced version of the input function `func`. The returned function takes the same
 * arguments as `func` and will only execute `func` after a delay of `delay` milliseconds has passed
 * since the last time the returned function was called. If the returned function is called again
 * before the delay has passed, the previous timeout is cleared and a new one is set.
 */
export const debounce = (func, delay) => {
    let timeoutId;

    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
};

export const pastFromClipboard = async () => {
    const text = await navigator.clipboard.readText();
    return text;
};

export const isExpiringSoon = (expirationDate) => {
    const currentDate = new Date();
    const oneDayBeforeExpiration = new Date(expirationDate);
    oneDayBeforeExpiration.setDate(oneDayBeforeExpiration.getDate() - 1);

    const hasExpired = currentDate > expirationDate;
    const expiringSoon = !hasExpired && currentDate >= oneDayBeforeExpiration;

    return { hasExpired, expiringSoon };
};

export const addDate = (date, noOfDays) => {
    const currentDate = new Date(date);
    currentDate.setDate(currentDate.getDate() + noOfDays);

    return currentDate;
};

export const convertToValidDate = (date) => {
    return moment(date, "DD/MM/YYYY HH:mm").format("MM/DD/YYYY HH:mm");
};

export const toDateTime = (secs) => {
    let t = new Date(1970, 0, 1); // Epoch
    t.setSeconds(secs);
    return t.toISOString();
};

export function subtractYearsFromDate(yearsToSubtract) {
    const currentDate = new Date();
    const newYear = currentDate.getFullYear() - yearsToSubtract;
    const currentMonth = currentDate.getMonth() + 1;
    const currentDay = currentDate.getDate();

    let newMonth = currentMonth;
    let newDay = currentDay;

    // Adjust for leap years
    if (currentMonth === 2 && currentDay === 29 && !isLeapYear(newYear)) {
        newMonth = 2;
        newDay = 28;
    }

    return `${newYear}-${String(newMonth).padStart(2, "0")}-${String(newDay).padStart(2, "0")}`;
}

// Function to check if a year is a leap year
function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

export const extractDateProperties = (date) => {
    let date_ = new Date(date),
        month = "" + (date_.getMonth() + 1),
        day = "" + date_.getDate(),
        year = `${date_.getFullYear()}`;

    if (day.length < 2) {
        day = `0${day}`;
    }
    if (month.length < 2) {
        month = `0${month}`;
    }
    return { year, month, day };
};
export function setToMidnight(date) {
    date.setHours(23, 59, 59, 999); // Set hours to 23 (11 PM), minutes to 59, seconds to 59, and milliseconds to 999
    return date;
}

export function formatLocalDateToCustomFormat(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}
export const dataURLtoFile = (dataurl, filename) => {
    const [, mime, data] = dataurl.match(/data:(.*?);base64,(.*)/);
    const arrayBuffer = new ArrayBuffer(data.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < data.length; i++) {
        uint8Array[i] = data.charCodeAt(i);
    }

    return new File([arrayBuffer], filename, { type: mime });
};

export function b64toBlob(b64Data, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = Array.from(slice, (char) => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
}

export const setMobileAuthCookies = ({
    userID,
    smeId,
    email,
    accessToken,
    refreshToken,
    tokenExpiryInMinutes,
}) => {
    Cookies.set("kudaUserID", userID);
    Cookies.set("kudaSmeID", smeId);
    Cookies.set("kudaUserEmail", email);
    Cookies.set("kudaAppToken", accessToken);
    Cookies.set("kudaAppRefreshToken", refreshToken);
    Cookies.set("expiresIn", tokenExpiryInMinutes);
};

export const extractFilenameFromUrl = (url) => {
    // Use the URL constructor to parse the URL
    const urlObject = new URL(url);

    // Extract the pathname from the URL
    const pathname = urlObject.pathname;

    // Split the pathname using '/' as the delimiter and get the last part (the filename)
    const filename = pathname.split("/").pop();

    return filename;
};

export const hasNA = (inputString) => {
    return inputString?.toLowerCase() === "n/a" || inputString?.toLowerCase() === "na";
};

export const generateNameVariations = (fullName, maxLength = 25) => {
    const [firstNamePart, suffix] = fullName?.split("|").map((part) => part.trim());
    const parts = firstNamePart.split(" ");
    const suffixWithHyphen = suffix ? ` - ${suffix}` : "";

    // Helper function to construct name ensuring it's within the maxLength
    function constructName(nameParts) {
        let constructedName = nameParts.join(" ") + suffixWithHyphen;
        if (constructedName.length > maxLength) {
            // If the constructed name is too long, start reducing from the longest part
            for (let i = 0; i < nameParts.length; i++) {
                const newPart = nameParts[i][0] + ".";
                constructedName = constructedName.replace(nameParts[i], newPart);
                if (constructedName.length <= maxLength) break;
            }
        }
        return constructedName.length <= maxLength
            ? constructedName
            : constructedName.slice(0, maxLength);
    }

    // Generate three variations based on different shortening strategies
    const variations = [
        constructName(parts.map((p) => p[0] + ".")), // All initials
        constructName([
            parts[0],
            ...parts.slice(1, -1).map((p) => p[0] + "."),
            parts[parts.length - 1],
        ]), // Shorten middle names to initials
        constructName([parts[0][0] + ".", ...parts.slice(1, -1), parts[parts.length - 1]]), // Shorten the first name
    ];

    return [...new Set(variations)];
};

/**
 * Determine if the browser is capable of Webauthn
 */
export const browserSupportsWebAuthn = () => {
    return (
        window?.PublicKeyCredential !== undefined &&
        typeof window.PublicKeyCredential === "function"
    );
};

export const toCamelCase = (str) => {
    return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
};

export const toSnakeCase = (str) => {
    return str.replace(/([A-Z])/g, "_$1").toLowerCase();
};

export const prependZeroToPhonenumber = (phoneNumber) => {
    // Remove any whitespace or non-digit characters
    phoneNumber = phoneNumber.trim().replace(/\D/g, "");

    // Check if the phone number starts with '0'
    if (phoneNumber.charAt(0) !== "0" && !phoneNumber.startsWith("234")) {
        // Prepend '0' if it doesn't
        phoneNumber = "0" + phoneNumber;
    }

    return phoneNumber;
};

export const convertToDateFromDDMMYYYY = (dateTimeString) => {
    // Split the input string into date and time components
    const [date, time] = dateTimeString.split(" ");

    // Split the date part into day, month, and year (in DD/MM/YYYY format)
    const [day, month, year] = date.split("/");

    // Reorder the date into the ISO format (YYYY-MM-DD) and combine with the time part
    // The ISO format ensures the date is interpreted correctly
    return `${year}-${month}-${day}T${time}`;
};

export const removeLeadingZeroOr234 = (phoneNumber) => {
    // Ensure the input is a string
    if (typeof phoneNumber !== "string") {
        return phoneNumber; // or throw an error, depending on your preference
    }

    // Remove any whitespace or non-digit characters
    let cleanedNumber = phoneNumber.trim().replace(/\D/g, "");

    // Remove leading '0' if present
    if (cleanedNumber.startsWith("0")) {
        return cleanedNumber.slice(1);
    }
    // Remove leading '234' if present
    else if (cleanedNumber.startsWith("234")) {
        return cleanedNumber.slice(3);
    }

    // Return the original cleaned number if no modifications were needed
    return cleanedNumber;
};

export const searchForStandaloneWord = (text, word) => {
    const paddedText = ` ${text} `;
    const paddedWord = ` ${word} `;

    const wordIndex = paddedText.indexOf(paddedWord);

    if (wordIndex !== -1) return true;
    return false;
};

export const padBase64 = (base64) => {
    // Calculate the number of padding characters needed
    const paddingNeeded = (4 - (base64.length % 4)) % 4;

    // Add '=' characters to the end of the string
    return base64 + "=".repeat(paddingNeeded);
};

export const decodeBase64 = (base64Text) => {
    const padBase64 = (txt) => txt.padEnd(txt.length + ((4 - (txt.length % 4)) % 4), "=");

    const toBuffer = (txt) => Uint8Array.from(txt, (c) => c.charCodeAt(0)).buffer;

    const parseBuffer = (buffer) => String.fromCharCode(...new Uint8Array(buffer));

    const parseBase64url = (txt) => {
        txt = txt.replaceAll("-", "+").replaceAll("_", "/"); // base64url -> base64
        return toBuffer(atob(txt));
    };

    const padded = padBase64(base64Text);
    const base64Url = parseBase64url(padded);
    const text = parseBuffer(base64Url);

    return text;
};

/**
 * Cleans out unwanted whitespace and non-printable characters
 * from a date string.
 * @param {string} dateStr
 * @returns {string}
 */
export const cleanDateString = (dateStr) => {
    if (typeof dateStr !== "string") return "";

    // 1) Replace specific invisible or non-breaking spaces:
    //    \u200B-\u200D (zero-width), \uFEFF (BOM), \u00A0 (NBSP), \u202F (Narrow NBSP), etc.
    let cleaned = dateStr.replace(/[\u200B-\u200D\uFEFF\u00A0\u202F]/g, " ");

    // 2) (Optional) Remove *all* non-ASCII characters if you want to be very strict
    //    You can comment this out if it breaks valid date strings in some locales
    // cleaned = cleaned.replace(/[^\x00-\x7F]/g, ' ');

    // 3) Collapse multiple spaces to one, and trim
    cleaned = cleaned.replace(/\s+/g, " ").trim();

    return cleaned;
};
